import { graphql } from "../graphql";
import query from "./query.gql";
import { IRepoErrors } from "../errors";
import { FetchResult } from "@apollo/client";
import { graphqlExtractGraphqlErrors } from "@/v2/util/graphql-extract-graphql-errors";
import { graphqlRemapValidationErrors } from "@/v2/util/graphql-remap-validation-errors";

export async function fetchOrganizations(
  organizationId?: string,
  outletsPerPage?: number
): Promise<Array<IFetchOrganizationsResponse>> {
  let response: FetchResult<any, Record<string, any>, Record<string, any>>;
  const errors: IRepoErrors<ValidationErrors> = {};

  try {
    response = await graphql.query({
      query,
      variables: {
        organizationId,
        outletsPerPage: outletsPerPage ?? 10,
      },
    });
  } catch (error) {
    errors.networkError = true;
    throw new FetchOrganizationsError(errors);
  }

  if (response.errors) {
    errors.graphqlError = graphqlExtractGraphqlErrors(response);
    errors.validationError = graphqlRemapValidationErrors(response);
    throw new FetchOrganizationsError(errors);
  }

  return response.data.organizations;
}

export class FetchOrganizationsError extends Error {
  errors: IRepoErrors<ValidationErrors>;

  constructor(errors: IRepoErrors<ValidationErrors>) {
    super("Error in repo: FetchOrganizations");
    this.errors = errors;
    this.name = this.constructor.name;
  }
}

type ValidationErrors = {};

interface IFetchOrganizationsResponse {
  id: string;
  name: string;
  businesses: Array<IBusiness>;
}

interface IBusiness {
  id: string;
  name: string;
  outlets: Array<IOutlets>;
}

interface IOutlets {
  id: string;
  name: string;
}
